import axios from 'axios'
import { api } from '@/services'
import { checklistApi } from '../checklistApi'

export const getSignedUrl = async (signedUrlData, uploadAddress) => {
  const { data } = await api.post(uploadAddress, signedUrlData)
  const external_filename = await data.external_filename
  const signedUrl = await data.url

  return { signedUrl, external_filename }
}

export const uploadToS3 = async (signedUrl, file) => {
  await axios.put(signedUrl, file, {
    headers: { 'Content-Type': file.type },
  })
}

export const attachToResource = async (signedUrlData, uploadAddress) => {
  return await api.post(uploadAddress, signedUrlData)
}

export const attachToResourceChecklist = async (data) => {
  const logo = {
    filename: data.filename,
    externalFilename: data.externalFilename,
    sequence: data.sequence,
    size: data.size,
  }

  await checklistApi.post('/web/company/setLogo', { logo: logo })
}

export const uploadLogoFileUrl = async (file) => await checklistApi.get(`web/company/uploadLogoFileUrl?filename=${file.name}&contentType=${file.type}`)

export const downloadLogoFileUrl = async () => await checklistApi.get('web/company/downloadLogoFileUrl')

export const uploadToS3Checklist = (signedUrl, file, acl, normalizedFilename) => {
  return axios.put(signedUrl, file, {
    headers: {
      'Content-Type': file.type,
      'x-amz-acl': acl ?? 'public-read',
      'content-disposition': `attachment; filename=${normalizedFilename ?? file.name}`
    }}
  )
}
